import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import BreadcrumbBar from "./components/BreadcrumbBar";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLangPath } from "./hooks/useLangPath";
import Seo from "./Seo";

function Commodities() {
  const { t } = useTranslation();
  const langPath = useLangPath();

  const items = [
    { label: "Brent Crude Oil", path: "/commodities/brent-crude-oil-ai-trading-predictions" },
    { label: "Natural Gas",     path: "/commodities/natural-gas-ai-trading-predictions" },
    { label: "Cocoa",           path: "/commodities/cocoa-ai-trading-predictions" },
    { label: "Sugar",           path: "/commodities/sugar-ai-trading-predictions" },
    { label: "Corn",            path: "/commodities/corn-ai-trading-predictions" },
    { label: "Soybean",         path: "/commodities/soybean-ai-trading-predictions" },
  ];

  return (
    <>
      <Seo
        title={t("commodities.pageTitle")}
        description={t("commodities.pageDesc")}
        canonical="/commodities"
        breadcrumbs={[
          { name: t("common.home"), path: "/" },
          { name: t("nav.commodities"), path: "/commodities" },
        ]}
      />
      <BreadcrumbBar crumbs={[{ label: t("common.home"), to: langPath("/") }, { label: t("nav.commodities") }]} />
      <Container style={{ paddingTop: 24, paddingBottom: 60 }}>
      <h1>{t("commodities.h1")}</h1>
      <p style={{ color: "#6c757d", marginBottom: 32 }}>{t("commodities.pageDesc")}</p>
      <Row>
        {items.map(({ label, path }) => (
          <Col md={4} key={path}>
            <Link to={langPath(path)} className="text-decoration-none">
              <Card className="mb-4"><Card.Body><Card.Title>{label}</Card.Title></Card.Body></Card>
            </Link>
          </Col>
        ))}
      </Row>
      </Container>
    </>
  );
}

export default Commodities;
